import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { ClickableThumbnail } from 'widget/components/thumbnail/thumbnail';

import { WixConnect } from 'shared/utils/wix-connect';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getVideosInRowCount } from 'shared/selectors/app-settings';

import { NextButton, PrevButton } from '../nav-button/nav-button';
import BaseVideosList from '../_base';

import styles from './classic.styl';


@connect((state, ownProps) => ({
  channelVideoIds: ownProps.paginatedChannelVideos.ids,
  prevPageIds: ownProps.paginatedChannelVideos.prevPageIds,
  nextPageIds: ownProps.paginatedChannelVideos.nextPageIds,
  goBack: ownProps.paginatedChannelVideos.goBack,
  goForward: ownProps.paginatedChannelVideos.goForward,
  videoByIds: getVideosGroupedByIds(state),
  locale: state.locale,
  videosInRow: getVideosInRowCount(state),
}))
@WixConnect(styles)
export default class ClassicVideosList extends BaseVideosList {
  static displayName = 'ClassicVideosList';

  static propTypes = {
    ...BaseVideosList.propTypes,
    isSelectedVideoIndicationDisabled: React.PropTypes.bool,
    isVideoPaused: React.PropTypes.bool,
    selectedVideoId: React.PropTypes.string,
    onThumbnailClick: React.PropTypes.func,
    locale: React.PropTypes.string,
  };

  get pageButtons() {
    const { prevPageIds, nextPageIds } = this.props;

    if (!prevPageIds.length && !nextPageIds.length) {
      return null;
    }

    return (
      <div styleName="buttons">
        <PrevButton disabled={!prevPageIds.length}
                    onClick={this.toPrevPage} />
        <NextButton disabled={!nextPageIds.length}
                    onClick={this.toNextPage} />
      </div>
    );
  }

  @autobind
  toVideoThumbnail(videoId) {
    const {
      videoByIds,
      onThumbnailClick,
      thumbnailSize,
      isVideoPaused,
      selectedVideoId,
      locale,
      isSelectedVideoIndicationDisabled,
    } = this.props;
    const { width, height } = thumbnailSize;
    const isVideoSelected = selectedVideoId === videoId && !isSelectedVideoIndicationDisabled;
    return (
      <ClickableThumbnail key={videoId}
                          styleName="thumbnail"
                          videoItem={videoByIds[videoId]}
                          nowPlaying={isVideoSelected && !isVideoPaused}
                          onClick={onThumbnailClick}
                          isSelected={isVideoSelected}
                          locale={locale}
                          width={width}
                          height={height} />
    );
  }

  render() {
    const { prevPageIds, nextPageIds, className } = this.props;
    const styleNames = classnames('container', {
      'with-paging': prevPageIds.length || nextPageIds.length,
    });

    return (
      <section className={`${className} qa-widget-video-list`}
               styleName={styleNames}>
        {this.list}
        {this.pageButtons}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list/classic/classic.js